import { ClassAttributes, HTMLAttributes } from 'react'
import Markdown, { ExtraProps } from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

const Img = ({
  ...props
}: ClassAttributes<HTMLImageElement> &
  HTMLAttributes<HTMLImageElement> &
  ExtraProps) => {
  return <img {...props} width={500} height={200} className="w-full h-auto" />
}

const components = {
  img: Img,
}

type MdFieldProps = {
  text: string
}

export const MarkDownField: React.FC<MdFieldProps> = ({ text }) => {
  return (
    <Markdown components={components} remarkPlugins={[remarkBreaks, remarkGfm]}>
      {text.replace(/\n\s*\n/g, '\n\n&nbsp;\n\n')}
    </Markdown>
  )
}
